/* src/app/workshop-defects/pages/workshop-defects-new/workshop-defects-new.component.scss */
/*# sourceMappingURL=workshop-defects-new.component.css.map */
